import { Flex } from "@chakra-ui/react";

import { ExitIcon } from "design_system/icons";
import { colors } from "src/colors";

import { OFText } from "../OFText";
import { VariantToastType } from "./type";
import useToastContent from "./useToastContent";

type Props = {
  message: string;
  onClose?: () => void;
  header?: string;
  variant?: VariantToastType;
};

export const ToastContent = ({ onClose, message, header, variant }: Props) => {
  const { background, icon, exitIconSize } = useToastContent({ variant });

  return (
    <Flex w={["360px", null, "auto"]} bg={background} p="16px" borderRadius="4px">
      <Flex>{icon}</Flex>
      <Flex flexDirection="column" flex={1} mx="15px">
        {header && (
          <OFText textStyle="h5" color={colors.white.off} mb="2">
            {header}
          </OFText>
        )}
        <OFText textStyle="body2" color={colors.white.off}>
          {message}
        </OFText>
      </Flex>
      <Flex cursor="pointer" onClick={onClose} alignItems="flex-start">
        <ExitIcon color={colors.white.off} size={exitIconSize} />
      </Flex>
    </Flex>
  );
};
